import React, { createElement } from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useGlobalState } from '../../providers/global';

function PrivateRoute({ component, ...rest }) {
	const { isAuthenticated } = useGlobalState();
	return (
		<Route
			{...rest}
			render={props =>
				isAuthenticated ? (
					createElement(component, props)
				) : (
					<Redirect to="/login" />
				)
			}
		/>
	);
}

PrivateRoute.propTypes = {
	component: PropTypes.any.isRequired,
	path: PropTypes.string,
};

export default PrivateRoute;